module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTQ3NS45IDY1NS42bC0xODguNy0yMTUuN2E0OCA0OCAwIDAgMSAzNi4xLTc5LjZoMzc3LjVhNDggNDggMCAwIDEgMzYuMSA3OS42bC0xOTAgMjE3LjEtMS45IDEuOS0xLjQgMS4zYTQ4IDQ4IDAgMCAxLTY3LjctNC41ek01MTIgNTk5LjdsMTUzLjUtMTc1LjRoLTMwN0w1MTIgNTk5Ljd6IiBmaWxsPSIjMCIgcC1pZD0iMTA4MiI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Caret down-outlined.svg
// module id = h5BY
// module chunks = 74